import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable()
export class CurrencyInputService {

    public transformInput(formControl: FormControl, rawValue: string | number = formControl.value): void {
        if (!rawValue.toString().includes('$')) {
            const currencyValue: string = `$${rawValue}`;
            formControl.setValue(currencyValue);
        } else {
            formControl.setValue(rawValue);
        }
    }

    public fetchRawInput(formControl: FormControl): number {
        return parseFloat(formControl.value.slice(1));
    }
}
